import React, { useEffect, useMemo, useCallback } from "react";
import {
	Avatar,
	Chip,
	Pagination,
	Table,
	TableBody,
	TableCell,
	TableColumn,
	TableHeader,
	TableRow,
	Tooltip,
} from "@heroui/react";
import { CheckIcon } from "../pages/ChatPage";
import HoverMedals from "./HoverMedals";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { parseMessage } from "./ChatArea";
import { useAnimationControls, motion } from "framer-motion";

function parseGuardNum(e) {
	var obj = JSON.parse(e.Extra);
	return obj.data.num;
}

function ActionTable(props) {
	const [currentPage, setCurrentPage] = React.useState(
		window.USER_PAGE
			? window.USER_PAGE
			: props.initialPage
				? props.initialPage
				: 1,
	);

	const redirect = useNavigate();

	const pageSize = parseInt(localStorage.getItem("defaultPageSize")) || 20;

	const [showName, setShowName] = React.useState(() => {
		return parseInt(localStorage.getItem("showName")) || 0;
	});

	useEffect(() => {
		setTimeout(() => {
			if (props.highLight) {
				const element = document.getElementById(props.highLight);
				if (element) {
					element.scrollIntoView({
						behavior: "smooth",
						block: "center",
					});
				}
			}
		}, 1000);
		console.log(props);
	}, []);

	useEffect(() => {
		//props.handlePageChange(currentPage);
		return () => {
			window.USER_PAGE = 1;
		};
	}, []);

	const columns = useMemo(() => {
		const cols = [
			{
				uid: "UserName",
				name: "Name",
			},
			{
				uid: "Liver",
				name: "Liver",
			},
			{
				uid: "StartAt",
				name: "Time",
			},
			{
				uid: "Message",
				name: "Message",
			},
		];

		return cols.filter((col) => {
			if (
				col.uid === "Liver" &&
				props.dataSource?.length > 0 &&
				props.dataSource[0].liver_id === undefined
			) {
				return false;
			}
			return true;
		});
	}, [props.dataSource]);

	const renderCell = useCallback(
		(item, columnKey, highLight) => {
			switch (columnKey) {
				case "UserName":
					return (
						<div
							className="hover:text-gray-500 flex items-center whitespace-nowrap min-w-[50px] cursor-pointer"
							onClick={() => {
								redirect("/user/" + item.from_id);
							}}
						>
							{!props.disableAvatar && item.from_id !== 0 && (
								<Avatar
									src={`${AVATAR_API}${item.from_id}`}
									className={"mr-2"}
								/>
							)}
							{item.from_name}
							{item.medal_level !== 0 && item.medal_level && (
								<Chip
									className="basis-64"
									startContent={
										item.guard_level ? (
											<img
												src={getGuardIcon(
													item.guard_level,
												)}
												alt="guard"
												width={20}
												height={20}
											/>
										) : (
											<CheckIcon size={18} />
										)
									}
									variant="faded"
									onClick={(e) => {
										e.stopPropagation();
										toSpace(item.medal_liver);
									}}
									style={{
										background: getColor(item.medal_level),
										color: "white",
										marginLeft: "8px",
									}}
								>
									{item.medal_name}
									<span className="ml-2 text-xs font-bold px-2 py-0.5 rounded-full">
										{item.medal_level}
									</span>
								</Chip>
							)}
						</div>
					);

				case "Liver":
					return (
						<NavLink
							className="flex hover:text-gray-500 whitespace-nowrap"
							to={"/liver/" + item.liver_id}
						>
							{!isMobile() && (
								<Avatar
									className="w-[40px] h-[40px]"
									src={`${AVATAR_API}${item.liver_id}`}
								/>
							)}
							<span className="ml-2 mt-2">{item.liver_name}</span>
						</NavLink>
					);

				case "StartAt":
					return (
						<span className="whitespace-nowrap">
							{timestampToDate(item.created_at).toLocaleString()}
						</span>
					);

				case "Message":
					if (item.action_type === 3) {
						var m = new Map();
						m.set("舰长", 138);
						m.set("提督", 1598);
						m.set("总督", 15998);

						if (item.gift_amount == null) {
							if (item.extra.includes("GUARD_BUY")) {
								var obj = JSON.parse(item.extra);
								item.gift_amount = obj.data.num;
								item.gift_price =
									(item.gift_amount * obj.data.price) / 1000;
							}
							if (item.extra === null || item.extra === "") {
								item.gift_amount =
									item.gift_price / m.get(item.gift_name);
							}
						}
					}
					if (item.action_type === 9 || item.action_type === 10) {
						item.gift_name = "发红包";
					}
					item.gift_price = formatFloat(item.gift_price);
					return (
						<div
							className={`transition-transform hover:text-gray-500 whitespace-nowrap ${
								item.action_type !== 1 ? "font-bold" : ""
							}`}
						>
					{/*		{GIFT_MAP.get(item.gift_name) && (
								<img
									src={GIFT_MAP.get(item.gift_name)}
									className="w-7 h-7 mr-0.5 inline"
									alt="gift"
								/>
							)}*/}
							<a
								title={'点击调整'}
								className={`cursor-pointer ${highLight ? "bg-blue-300" : ""}`}
								onClick={() => {
									if (props.disableLocate) return;
									axios
										.get(
											`/api/actions/locate?id=${item.id}&live=${item.live}&size=${pageSize}`,
										)
										.then((response) => {
											window.open(
												`/lives/${item.live}?page=${response.data.page}&highLight=${item.id}`,
											);
										});
								}}
								dangerouslySetInnerHTML={{
									__html:
										item.action_type === 9
											? "[红包] " +
											JSON.parse(item.extra)
												.awards?.[0]
												?.gift_name +
											" *" +
											JSON.parse(item.extra)
												.awards?.[0]?.num
											: item.action_type === 10
												? `天选开奖 (共 ${JSON.parse(item.extra).total_num || 0} 人)`
												: item.gift_name ||
												parseMessage(
													item.extra,
													item.emotes ??
													new Map(),
												),
								}}
							/>

							{(item.action_type === 2 ||
								item.action_type === 3) && (
								<span>
									*{item.gift_amount}{" "}
									{item.gift_price
										? ` ￥ ${item.gift_price}`
										: ""}
								</span>
							)}
							{item.action_type === 4 && (
								<span>
									{item.gift_price
										? ` ￥ ${item.gift_price}`
										: ""}
								</span>
							)}
						</div>
					);

				default:
					return null;
			}
		},
		[pageSize],
	);


	return (
		<div
			className="w-full overflow-x-scroll scrollbar-hide"
			ref={props.ref}
		>
			<>
				<Table
					hideHeader
					removeWrapper
					bottomContent={
						<div className="flex w-full justify-center">
							<Pagination
								isCompact
								showControls
								showShadow
								color="secondary"
								page={currentPage}
								total={
									Math.ceil((props.total || 0) / pageSize) || 1
								}
								onChange={(page) => {
									setCurrentPage(page);
									props.handlePageChange(page, pageSize);
								}}
							/>
						</div>
					}
					isStriped
					classNames={{
						wrapper: "max-w-full overflow-x-auto",
						table: "",
					}}
					isHeaderSticky
					aria-label="Action Table"
				>
					<TableHeader columns={columns}>
						{(column) => (
							<TableColumn key={column.uid}>
								{column.name}
							</TableColumn>
						)}
					</TableHeader>
					<TableBody
						items={props.dataSource || []}
						emptyContent="暂无数据"
					>
						{(item) => (
							<TableRow
								key={item.ID || item.id || Math.random()}
								id={item.id}
							>
								{(columnKey) => (
									<TableCell>
										{renderCell(
											item,
											columnKey,
											item.id + "" === props.highLight,
										)}
									</TableCell>
								)}
							</TableRow>
						)}
					</TableBody>
				</Table>
			</>
		</div>
	);
}

export default ActionTable;
